import { render, staticRenderFns } from "./CreditList.vue?vue&type=template&id=2c4247e0&scoped=true"
import script from "./CreditList.vue?vue&type=script&lang=ts"
export * from "./CreditList.vue?vue&type=script&lang=ts"
import style0 from "./CreditList.vue?vue&type=style&index=0&id=2c4247e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4247e0",
  null
  
)

export default component.exports